import React, { useState } from 'react';
import { authService } from '../auth';
import axios from 'axios';
import { load } from "@cashfreepayments/cashfree-js";
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const ErorrMsgPopUp = withReactContent(alertPopUp)

const CashfreeModal = (props) => {

    const { total, onCashFreePaymentSuccess } = props;
    const [userData] = useState(authService.getUserDetailsFromLocalStorage());
    const [loading, setLoading] = useState(false);

    const startPayment = async () => {
        window.$("#pGatewaypop").modal("hide");
        window.$("#stTopUpPop").modal("hide");
        setLoading(true);
        let postData = {
            amount: total,
            paymentGatewayType: 'CASH_FREE',
            userId: userData?.userId,
            currencyType: 'INR'
        }
        const res = await fetch(`${process.env.REACT_APP_userServiceURL}/payment/create_order`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData),
        });
        const data = await res.json();
        let sessionId = data?.body?.sessionId;
        if (!sessionId) {
            alert('Failed to get session ID');
            setLoading(false);
            return;
        }
        const cashfree = await load({
            mode: process.env.REACT_APP_environment === "dev" ? 'sandbox' : "production",
        });
        try {
            const result = await cashfree.checkout({
                paymentSessionId: sessionId,
                redirectTarget: "_modal",
            });
            if (result?.paymentDetails?.paymentMessage) {
                checkPaymentStatus(data?.body);
            }
        } catch (error) {
            console.error("Cashfree checkout error: ", error);
        }
        setLoading(false);
    };

    const checkPaymentStatus = (paymentData) => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/payment/get_payment_status?orderId=${paymentData?.orderId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then((response) => {
            if (response?.data?.status === '200 OK') {
                paymentData.amount = total;
                onCashFreePaymentSuccess(paymentData, response?.data?.body);
            }
        }).catch((err) => {
            if (err && err.response) {
                ErorrMsgPopUp.fire({
                    didOpen: () => {
                        ErorrMsgPopUp.clickConfirm()
                    }
                }).then(() => {
                    return ErorrMsgPopUp.fire(<p>{"Payment failed"}</p>)
                })
            }
        });
    };

    return (
        <button className='btn credit-points-proceed m-1' onClick={startPayment} disabled={loading}>
            {/* <img
                src="https://images.livemint.com/img/2021/06/07/600x338/pic02_1590467342454_1623058430991.jpg"
                alt="Cashfree"
                style={{ height: '58px' }}
            /> */}
            Pay Now
        </button>
    );
};

export default CashfreeModal;